import React, { Component } from 'react';
import Axios from "../../axios";
import { logout, Headers } from "../../axios/axios_config";
import Spinner from "../../components/spinner";
import { loadState, removeItems } from '../../redux/helper/local_storage_helper';

export const LOGOUT = 'fanpage/Logout';

const localData = ['game_info', 'credits', '1', '2', 'game_data', 'app_user', 'startnew_match', 'startnew_chart', 'curr_entry', 'genreType'];

class Logout extends Component {
  constructor() {
    super();

    this.state = {
      isLoading: true
    }
  }

  componentWillMount() {
    const user = loadState('app_user');
    if (user && user.refresh_token) {
      Axios.post(logout.url, {
        "RefreshToken": user.refresh_token,
        "UniqueDeviceId": "3"
      }, Headers())
        .then(response => {
          const { data } = response;
          if (data && data.Item) {
            Promise.resolve((this.removeCredentials(this.props.dispatch))).then(() => {
              this.setState({ isLoading: false });
              window.location.href = '/Hitmaker';
            });
          }
        })
        .catch(err => {
          localStorage.clear();
          removeItems(localData);
          window.location.href = '/Hitmaker';
          console.log(
            'Unable to logout.',
            err
          );
        });
    } else {
      this.setState({ isLoading: false });
      window.location.href = '/Hitmaker';
    }
  }

  removeCredentials = (dispatch) => {
    localStorage.clear();
    removeItems(localData);
    dispatch({ type: LOGOUT });
  }

  render() {
    if (this.state.isLoading) return <Spinner />
    return null;
  }
}

export default Logout;
